import React from 'react';
import Card from 'kepler/lib/components/Card';
import Col from 'kepler/lib/components/Col';
import Row from 'kepler/lib/components/Row';
import { quizResultExtra } from '../lib/quizSteps';
import PropTypes from 'prop-types';
import { extraCardToFPTIMapping } from '../lib/quizStaticMapping';
import { get } from 'lodash';
class QuizResultExtraCard extends React.Component {
  fptiExtraCardClick = extraCardName => {
    const { location, fptiHelper } = this.props;
    fptiHelper.fptiClick({
      page: `main:businessweb:mep:dashboard:main:quiz:results`,
      entry_point: get(location, 'search', '').includes('appcenter=true'),
      link: get(extraCardToFPTIMapping, `${extraCardName}`)
    });
  };
  getImageStyle = (data, extraCardName) => {
    let styles = {
      background: `url(${data.icon}) no-repeat center center`
    };
    if (extraCardName === 'restart') {
      styles.position = 'absolute';
      styles.top = '-5px';
    }
    return styles;
  };
  render() {
    const { extraCardName } = this.props;
    let data = quizResultExtra(extraCardName),
      imageStyle = this.getImageStyle(data, extraCardName);
    return (
      <Card className="results-extras">
        <Row>
          <Col
            className="results-extra-icon-mobile"
            sm="10%"
            style={{ paddingLeft: '0px', position: 'relative' }}
          >
            <div className="results-extras-icon" style={imageStyle} />
          </Col>
          <Col
            className="results-extra-content-mobile"
            sm="90%"
            style={{ paddingLeft: '20px' }}
          >
            <h4 className="results-extras-title">{data.header}</h4>
            <p className="results-extras-subtitle">{data.subtext}</p>
            <a
              target="_blank"
              onClick={() => {
                this.fptiExtraCardClick(extraCardName);
              }}
              href={data.link}
              className="results-extras-link"
            >
              {data.linkText}
            </a>
          </Col>
        </Row>
      </Card>
    );
  }
}
QuizResultExtraCard.propTypes = {
  extraCardName: PropTypes.string,
  location: PropTypes.object,
  fptiHelper: PropTypes.object
};
export default QuizResultExtraCard;
